document.addEventListener('DOMContentLoaded', function () {
  var t=document.getElementById('GiftToggle'),f=document.getElementById('GiftFields'),
      n=document.getElementById('GiftSenderName'),m=document.getElementById('GiftMessage'),
      err=document.getElementById('GiftNameError');
  if(!t){ console.warn('[gift] GiftToggle not found'); return; }
  var timer;
  function doSave(){
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:{
        'ギフト':t.checked?'はい':'','贈り主氏名':t.checked?(n.value||''):'',
        'ギフトメッセージ':t.checked?(m.value||''):''}})})
      .then(function(r){return r.json();})
      .then(function(c){ console.log('[gift] saved', c.attributes); });
  }
  function save(){ clearTimeout(timer); timer=setTimeout(doSave,300); }
  function bad(){ return t.checked && !n.value.trim(); }
  function guard(){
    var b=bad();
    if(err) err.style.display=b?'block':'none';
    n.style.borderColor=b?'#b23':'rgba(120,100,70,.4)';
    var btn=document.querySelector('[name="checkout"]');
    var dyn=document.querySelector('.cart__dynamic-checkout-buttons');
    if(btn){ btn.disabled=b; btn.style.opacity=b?'0.5':''; btn.style.pointerEvents=b?'none':''; }
    if(dyn){ dyn.style.display=b?'none':''; }
  }
  t.addEventListener('change',function(){ f.style.display=t.checked?'block':'none'; doSave(); guard(); });
  [n,m].forEach(function(el){ if(el) el.addEventListener('input',function(){ save(); guard(); }); });

  // ① クリックを文書レベルで捕捉（後から描画されるボタンにも効く）
  document.addEventListener('click',function(e){
    var el=e.target.closest && e.target.closest('[name="checkout"], .cart__dynamic-checkout-buttons, button[type="submit"]');
    if(el && bad()){
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      guard(); n.focus(); alert('贈り主のお名前を入力してください。');
    }
  }, true);

  // ② カートフォームの送信自体もブロック（Enter送信や他経路対策）
  var form=document.getElementById('cart')||document.querySelector('form[action*="/cart"]');
  if(form){ form.addEventListener('submit',function(e){
    if(bad()){ e.preventDefault(); e.stopPropagation(); guard(); n.focus(); alert('贈り主のお名前を入力してください。'); }
  }, true); }

  guard();
  console.log('[gift] init OK (guard v2)');
});